import { Component } from '@angular/core';

@Component({
    selector: 'app-root',
    templateUrl: './signup.html',
    styleUrls: ['./signup.scss']
})
export class SignUpComponent {   
}


// WEBPACK FOOTER //
// ./src/app/pages/signup/signup.ts